import { SimulateRepository } from 'application/repositories/SimulateRepository';
import { PostPutDeleteBaseResponse } from 'domain/entities/CommonEntity';
import {
    CfSimCompareResponse,
    CfSimDetailResponse,
    SimHistoryResponse,
    SimListResponse,
    SimulateAssessmentResponse,
    SimulateBreakEntity,
    SimulateBreakGetResponse,
    SimulateCashFlowEntity,
    SimulateCashFlowGetResponse,
    SimulateCashFlowListedPropertyResponse,
    SimulateCreateCashFlowEntity,
    SimulateEntity,
    SimulateLoanEntity,
    SimulateLoanFinancialResponse,
    SimulateLoanResponse,
    SimulateSaleResponse,
} from 'domain/entities/SimulateEntity';
import axiosConfig from 'infrastructure/config/axios';

export class SimulateAPI implements SimulateRepository {
    async createSimulateSale(payload: SimulateEntity): Promise<PostPutDeleteBaseResponse> {
        const API_URL = '/simulate/sales/create';
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async getSimulateSale(payload: SimulateEntity): Promise<SimulateSaleResponse> {
        const API_URL = '/simulate/sales/get?isLogin=0';
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async getSimulateLoadFinancial(checkFlag?: string): Promise<SimulateLoanFinancialResponse> {
        const API_URL = `/master/loan-financial-institutions/list?isLogin=0${checkFlag ? `&checkFlag=${checkFlag}` : ''}`;
        const response = await axiosConfig.getAxiosConfig().get(API_URL, {});
        return response.data;
    }
    async getMasterFee(): Promise<SimulateLoanFinancialResponse> {
        const API_URL = '/master/loan-financial-institutions/master-fee?isLogin=0';
        const response = await axiosConfig.getAxiosConfig().get(API_URL, {});
        return response.data;
    }
    async createSimulateCashFlow(
        payload: SimulateCashFlowEntity,
    ): Promise<PostPutDeleteBaseResponse> {
        const API_URL = '/simulate/cash-flow/create';
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async getSimulateCashFlow(
        payload: SimulateCashFlowEntity,
    ): Promise<SimulateCashFlowGetResponse> {
        const API_URL = '/simulate/cash-flow/get?isLogin=0';
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async createSimulateLoan(payload: SimulateLoanEntity): Promise<PostPutDeleteBaseResponse> {
        const API_URL = '/simulate/loan/create';
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async createTempSimulateLoan(payload: SimulateLoanEntity): Promise<PostPutDeleteBaseResponse> {
        const API_URL = '/simulate/loan/temp?isLogin=0';
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async getSimulateLoan(params: { simId: number }): Promise<SimulateLoanResponse> {
        const API_URL = '/simulate/loan/get';
        const response = await axiosConfig.getAxiosConfig().get(API_URL, { params });
        return response.data;
    }
    async getSimulateLoanDefaultValue(): Promise<SimulateLoanResponse> {
        const API_URL = '/simulate/loan/get/default?isLogin=0';
        const response = await axiosConfig.getAxiosConfig().get(API_URL);
        return response.data;
    }
    async createSimulateBreak(payload: SimulateBreakEntity): Promise<PostPutDeleteBaseResponse> {
        const API_URL = '/simulate/break-even-point/create';
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }

    async getSimulateBreak(payload: SimulateBreakEntity): Promise<SimulateBreakGetResponse> {
        const API_URL = '/simulate/break-even-point/get?isLogin=0';
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }
    async getSimulateAssessment(params: {
        listedPropertyId: number;
    }): Promise<SimulateAssessmentResponse> {
        const API_URL = '/simulate/cash-flow/assessments/get';
        const response = await axiosConfig.getAxiosConfig().get(API_URL, { params });
        return response.data;
    }
    async createCashFlowSimWithListedProperty(
        payload: SimulateCreateCashFlowEntity,
    ): Promise<PostPutDeleteBaseResponse> {
        const API_URL = '/simulate/cash-flow/listed-property/create';
        const response = await axiosConfig.getAxiosConfig().post(API_URL, payload);
        return response.data;
    }
    async getCashFlowSimOfListedProperty(params: {
        simId: number;
    }): Promise<SimulateCashFlowListedPropertyResponse> {
        const API_URL = '/simulate/cash-flow/listed-property/get';
        const response = await axiosConfig.getAxiosConfig().get(API_URL, { params });
        return response.data;
    }
    async updateCashFlowSim(
        payload: SimulateCreateCashFlowEntity,
    ): Promise<PostPutDeleteBaseResponse> {
        const API_URL = '/simulate/cash-flow/listed-property/update';
        const response = await axiosConfig.getAxiosConfig().put(API_URL, payload);
        return response.data;
    }
    async getSimHistory(type?: string): Promise<SimHistoryResponse> {
        const API_URL = `/setting/history-simulate${type ? `?type=${type}` : ''}`;
        const response = await axiosConfig.getAxiosConfig().get(API_URL);
        return response.data;
    }
    async getSimModalList(type?: string): Promise<SimListResponse> {
        const API_URL = `/setting/list-simulate${type ? `?type=${type}` : ''}`;
        const response = await axiosConfig.getAxiosConfig().get(API_URL);
        return response.data;
    }
    async getDataCompare(params: { id1: number; id2: number }): Promise<CfSimCompareResponse> {
        const API_URL = '/setting/compare-simulate';
        const response = await axiosConfig.getAxiosConfig().get(API_URL, { params });
        return response.data;
    }
    async getSimDetail(id: number): Promise<CfSimDetailResponse> {
        const API_URL = `/setting/detail/${id}`;
        const response = await axiosConfig.getAxiosConfig().get(API_URL);
        return response.data;
    }
}
